import { c as _c } from "react/compiler-runtime";
import { useEffect, type CSSProperties, type ReactNode } from 'react';
import { FullModal } from '@sbt-web/ui';
import classnames from './index.module.scss';
const renderIframe = (fullscreen: boolean, opened: boolean, flowUrl: string): ReactNode => {
  const flowOrigin = flowUrl && new URL(flowUrl).origin;
  const styles: CSSProperties = {
    display: 'block',
    width: '100%'
  };
  if (fullscreen) {
    styles.height = '85vh';
  } else {
    styles.height = '80vh';
  }
  if (!opened) {
    styles.display = 'none';
  }
  return <iframe className={classnames['iframe']} title="flowdialog-iframe" key={flowUrl} src={flowUrl} style={styles} frameBorder="0" scrolling="auto" allow={`geolocation ${flowOrigin}; payment ${flowOrigin};`} />;
};
export interface FlowDialogProps {
  fullscreen: boolean;
  opened: boolean;
  onCloseIntent: () => void;
  flowUrl: string;
}
export const FlowDialog = t0 => {
  const $ = _c(14);
  const {
    fullscreen,
    opened,
    onCloseIntent,
    flowUrl
  } = t0;
  let t1;
  if ($[0] !== flowUrl || $[1] !== fullscreen || $[2] !== opened) {
    t1 = renderIframe(fullscreen, opened, flowUrl);
    $[0] = flowUrl;
    $[1] = fullscreen;
    $[2] = opened;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const iframe = t1;
  let t2;
  let t3;
  if ($[4] !== onCloseIntent) {
    t2 = () => {
      const cb = event => {
        if (event.data?.close) {
          onCloseIntent();
        }
        return false;
      };
      window.addEventListener("message", cb, false);
      return () => window.removeEventListener("message", cb);
    };
    t3 = [onCloseIntent];
    $[4] = onCloseIntent;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      w: "640px",
      h: "100%"
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== iframe) {
    t5 = <div className={classnames["iframe-container"]}>{iframe}</div>;
    $[8] = iframe;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== onCloseIntent || $[11] !== opened || $[12] !== t5) {
    t6 = <FullModal title="Acquista a distanza" open={opened} onClose={onCloseIntent} size={t4} overflowHidden={true} inset={true}>{t5}</FullModal>;
    $[10] = onCloseIntent;
    $[11] = opened;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};